import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'

const { Menu: DropdownMenu } = Dropdown

function firstNonUndefined(values) {
  return values.find(val => val !== undefined)
}

export default function Menu({ data }) {
  return (
    <DropdownMenu>
      {data.map(({ id, key, name, title, value }, index) => (
        <DropdownMenu.Item
          key={id || key || index}
          itemKey={firstNonUndefined([value, id, key, name])}
        >
          {name || title || key}
        </DropdownMenu.Item>
      ))}
    </DropdownMenu>
  )
}
